'use client';

import { useState } from 'react';
import { XIcon, ChatAIIcon } from './chatbot-icons';
import { ChatBubbleProps } from './models';
import { CHATBOT_TEXT } from './text';

export function ChatBubble({ onToggle, isOpen, unreadCount = 0 }: ChatBubbleProps) {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <div className="fixed bottom-6 right-6 z-40 flex flex-col items-end gap-3">
            {/* Animated tooltip */}
            {!isOpen && isHovered && (
                <div className="bg-gray-900 text-white text-sm px-4 py-2 rounded-lg shadow-lg whitespace-nowrap animate-fade-in">
                    <div className="flex items-center gap-2">
                        <ChatAIIcon className="h-4 w-4 flex-shrink-0" size={16} />
                        <span>{CHATBOT_TEXT.askOurAI}</span>
                    </div>
                </div>
            )}

            {/* Main bubble button */}
            <button
                onClick={() => onToggle(!isOpen)}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                className={`w-16 h-16 rounded-full shadow-2xl transition-all duration-300 flex items-center justify-center relative group bg-[#05a6f0] ${
                    !isOpen ? 'hover:scale-110 hover:shadow-xl' : ''
                }`}
                aria-label="Toggle AI chat"
            >
                {/* Animated background glow */}
                {!isOpen && (
                    <div className="absolute inset-0 rounded-full bg-[#05a6f0] opacity-0 group-hover:opacity-20 blur-xl transition-opacity" />
                )}

                {isOpen ? (
                    <XIcon className="w-7 h-7 text-white relative z-10" />
                ) : (
                    <>
                        <ChatAIIcon className="relative z-10 h-7 w-7" size={28} />
                        {unreadCount > 0 && (
                            <div className="absolute -top-1 -right-1 bg-red-500 text-white text-xs font-bold rounded-full w-6 h-6 flex items-center justify-center shadow-lg">
                                {unreadCount > 9 ? '9+' : unreadCount}
                            </div>
                        )}
                    </>
                )}
            </button>
        </div>
    );
}
